<template>
	<a-card :bordered="false">
		<SearchForm
			:form-state="searchFormState"
			:form-fields="[
				{ label: '邮件引擎', name: 'engine', span: 8 },
				{ label: '主题关键词', name: 'searchKey', span: 8 }
			]"
			@search="table.refresh(true)"
			@reset="handleReset"
			ref="searchFormRef"
		>
			<template #engine="{ formState }">
				<a-select v-model:value="formState.engine" :options="engineOptions" placeholder="请选择邮件引擎" allow-clear></a-select>
			</template>
			<template #searchKey="{ formState }">
				<a-input v-model:value="formState.searchKey" placeholder="请输入邮件主题关键词"></a-input>
			</template>
		</SearchForm>
		<s-table
			ref="table"
			:columns="columns"
			:data="loadData"
			:expand-row-by-click="true"
			:alert="options.alert.show"
			bordered
			:row-key="(record) => record.id"
			:row-selection="options.rowSelection"
			:operator-config="operatorConfig"
		>
			<template #bodyCell="{ column, record }">
				<template v-if="column.dataIndex === 'engine'">
					{{ $TOOL.dictTypeData('EMAIL_ENGINE', record.engine) }}
				</template>
				<template v-if="column.dataIndex === 'action'">
					<a @click="detailRef.onOpen(record)">详情</a>
					<a-divider type="vertical" />
					<a-popconfirm title="删除此邮件？" @confirm="deleteEmail(record)">
						<a-button type="link" danger size="small">删除</a-button>
					</a-popconfirm>
				</template>
			</template>
		</s-table>
	</a-card>
	<Form ref="form" @successful="table.refresh(true)" />
	<detail ref="detailRef" />
</template>
<script setup name="devEmailIndex">
	import { message } from 'ant-design-vue'
	import emailApi from '@/api/dev/emailApi'
	import Form from './form.vue'
	import { getCurrentInstance } from 'vue'
	import detail from './detail.vue'
	const { proxy } = getCurrentInstance()
	const table = ref(null)
	const form = ref()
	const searchFormRef = ref()
	let searchFormState = reactive({})
	const deleteLoading = ref(false)
	const detailRef = ref()
	const columns = [
		{
			title: '邮件引擎',

			dataIndex: 'engine',
			ellipsis: true
		},
		{
			title: '发件人邮箱',

			dataIndex: 'sendAccount'
		},
		{
			title: '发件人昵称',

			dataIndex: 'sendUser'
		},
		{
			title: '接收人',

			dataIndex: 'receiveAccounts',
			ellipsis: true
		},
		{
			title: '邮件主题',

			dataIndex: 'subject',
			ellipsis: true
		},
		{
			title: '标签名',

			dataIndex: 'tagName',
			ellipsis: true
		},
		{
			title: '操作',

			dataIndex: 'action',
			align: 'center',
			width: 150
		}
	]
	let selectedRowKeys = ref([])
	// 列表选择配置
	const options = {
		alert: {
			show: false,
			clear: () => {
				selectedRowKeys = ref([])
			}
		},
		rowSelection: {
			onChange: (selectedRowKey, selectedRows) => {
				selectedRowKeys.value = selectedRowKey
			}
		}
	}
	// 表格查询 返回 Promise 对象
	const loadData = (parameter) => {
		return emailApi.emailPage(Object.assign(parameter, searchFormState)).then((data) => {
			return data
		})
	}
	const engineOptions = proxy.$TOOL.dictTypeList('EMAIL_ENGINE').map((item) => {
		return {
			value: item['dictValue'],
			label: item['name']
		}
	})
	// 删除
	const deleteEmail = (record) => {
		let params = [
			{
				id: record.id
			}
		]
		emailApi.emailDelete(params).then(() => {
			table.refresh(true)
		})
	}
	// 批量删除
	const deleteBatchEmail = () => {
		if (selectedRowKeys.value.length < 1) {
			message.warning('请选择一条或多条数据')
			return false
		}
		const params = selectedRowKeys.value.map((m) => {
			return {
				id: m
			}
		})
		emailApi.emailDelete(params).then(() => {
			table.value.clearRefreshSelected()
		})
	}

	// 重置表单
	const handleReset = () => {
		searchFormRef.value?.resetFields()
	}

	// 操作按钮配置
	const operatorConfig = computed(() => [
		{
			text: '发送邮件',
			icon: 'fa fa-plus',
			onClick: () => form.value.onOpen()
		},
		{
			text: '删除',
			icon: 'fa fa-trash',
			danger: true,
			onClick: deleteBatchEmail,
			disabled: selectedRowKeys.value.length === 0
		}
	])
</script>
<style scoped>
	.ant-form-item {
		margin-bottom: 0 !important;
	}
	.snowy-buttom-left {
		margin-left: 8px;
	}
</style>
